import React from "react";
import { content } from "../data";
import "./inexoPrivacy.css";

function InexoPrivacy({ lang = "tr" }) {
  const currentLang = content[lang] ? lang : "tr";
  const data = content[currentLang].inexoPrivacy;
  const isTr = currentLang === "tr";

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="legal-page-wrapper">
      <div className="legal-container">

        {/* Formal Document Header */}
        <header className="legal-header">
          <div className="legal-preheader">
            <span className="legal-tag">{data.tag}</span>

            <div className="legal-actions">
              <button onClick={handlePrint} className="print-btn" title="Yazdır veya PDF olarak kaydet">
                <span>🖨️</span> {data.printBtn}
              </button>
            </div>
          </div>

          <h1 className="legal-title">{data.title}</h1>
          <p className="legal-subtitle">{data.subtitle}</p>

          <div className="legal-meta-bar">
            <div className="meta-field">
              <span className="meta-label">{data.meta.appLabel}</span>
              <span className="meta-value">{data.meta.appName}</span>
            </div>
            <div className="meta-field">
              <span className="meta-label">{data.meta.packageLabel}</span>
              <span className="meta-value mono">{data.meta.packageId}</span>
            </div>
            <div className="meta-field">
              <span className="meta-label">{data.meta.developerLabel}</span>
              <span className="meta-value">{data.meta.developerName}</span>
            </div>
            <div className="meta-field">
              <span className="meta-label">{data.meta.updatedLabel}</span>
              <span className="meta-value">{data.meta.updatedDate}</span>
            </div>
          </div>
        </header>

        {/* Regulatory Compliance Statement */}
        <div className="compliance-banner">
          <strong>{isTr ? "Yasal Uyum ve Bildirim:" : "Regulatory Compliance Statement:"}</strong>{" "}
          {data.complianceNotice}
        </div>

        {/* Main Two-Column Layout */}
        <div className="legal-layout">

          {/* Sticky Table of Contents */}
          <aside className="legal-toc">
            <div className="toc-title">{data.tocTitle}</div>
            <nav className="toc-list">
              {data.toc.map((item) => (
                <a key={item.id} href={`#${item.id}`} className="toc-link">
                  {item.label}
                </a>
              ))}
            </nav>
          </aside>

          {/* Policy Body */}
          <main className="legal-body">

            {isTr ? (
              /* ==================== TÜRKÇE HUKUKİ METİN ==================== */
              <div>
                <section id="sec-overview" className="legal-section">
                  <h2 className="legal-section-title">
                    <span className="section-num">1.0</span> Genel Bakış ve Temel Felsefemiz
                  </h2>
                  <p className="legal-paragraph">
                    <strong>Inexo Finance</strong>, kullanıcıların kişisel bütçelerini, harcamalarını, gelirlerini ve birikim hedeflerini gizlilik odaklı bir yaklaşımla takip etmelerini sağlayan modern bir finans takip uygulamasıdır.
                  </p>
                  <div className="legal-clause">
                    <strong>En Temel İlkemiz:</strong>
                    Finansal verileriniz tamamen size aittir. Inexo Finance, kullanıcıların gelir veya harcama verilerini hiçbir harici sunucuya aktarmaz, saklamaz veya üçüncü taraflara satmaz.
                  </div>
                </section>

                <section id="sec-data" className="legal-section">
                  <h2 className="legal-section-title">
                    <span className="section-num">2.0</span> Toplanan ve İşlenen Veriler
                  </h2>

                  <h3 className="legal-subsection-title">a. Finansal Kayıtlar ve Notlar (%100 Çevrimdışı / Yerel Depolama)</h3>
                  <p className="legal-paragraph">
                    Eklediğiniz harcamalar, gelirler, bütçe limitleri, tasarruf hedefleri ve işlemlerle ilgili notlar yalnızca cihazınızda bulunan yerel <strong>SQLite</strong> veri tabanında saklanır.
                  </p>
                  <p className="legal-paragraph">
                    Bu veriler cihazınızın dışına çıkmaz ve geliştirici dahil hiç kimse tarafından uzaktan erişilemez.
                  </p>

                  <h3 className="legal-subsection-title">b. Biyometrik Kimlik Doğrulama (Parmak İzi / Yüz Tanıma)</h3>
                  <p className="legal-paragraph">
                    Inexo Finance, uygulamanızı izinsiz erişimlere karşı korumak için isteğe bağlı biyometrik kilit sunar. Kimlik doğrulama işlemleri tamamen cihazınızın işletim sistemi donanımı (Android Keystore / BiometricPrompt, iOS LocalAuthentication / Secure Enclave) tarafından yürütülür.
                  </p>
                  <p className="legal-paragraph">
                    Uygulamamız biyometrik verilerinizi (parmak izi görseli, yüz haritası vb.) asla görmez, toplayamaz veya saklayamaz; işletim sisteminden yalnızca işlemin "başarılı" veya "başarısız" olduğuna dair bir onay alır.
                  </p>

                  <h3 className="legal-subsection-title">c. Bildirimler ve Alarmlar</h3>
                  <p className="legal-paragraph">
                    Uygulama, günlük harcama hatırlatması ve yaklaşan sabit faturalarınız için yerel bildirimler planlar. Bildirimler cihazınızın dahili zamanlayıcısı üzerinde yerel olarak çalışır; harici bir push bildirim sunucusuna kişisel veriniz gönderilmez.
                  </p>
                </section>

                <section id="sec-admob" className="legal-section">
                  <h2 className="legal-section-title">
                    <span className="section-num">2.1</span> Reklam Hizmetleri (Google AdMob)
                  </h2>
                  <p className="legal-paragraph">
                    Uygulamanın ücretsiz sunulabilmesi için Google Mobile Ads (AdMob) SDK'sı kullanılmaktadır.
                  </p>
                  <ul className="legal-list">
                    <li>
                      AdMob, reklam sunumu, sahtekarlık tespiti ve reklam performansı analizi amacıyla Google politikalarına uygun olarak cihaz tanımlayıcılarını (Google Reklam Kimliği - GAID) ve yaklaşık konum/cihaz bilgilerini işleyebilir.
                    </li>
                    <li>
                      <strong>Kişiselleştirilmemiş Reklamlar:</strong> Inexo Finance, AdMob isteklerinde <strong>Kişiselleştirilmemiş Reklamlar (Non-Personalized Ads)</strong> modunu destekler ve finansal kayıtlarınız reklam sistemleriyle kesinlikle eşleştirilmez.
                    </li>
                    <li>
                      Google'ın verileri nasıl işlediğine ilişkin detaylar için <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" style={{ color: "var(--secondary)", textDecoration: "underline" }}>Google Gizlilik ve Şartlar</a> sayfasını inceleyebilirsiniz.
                    </li>
                  </ul>
                </section>

                <section id="sec-permissions" className="legal-section">
                  <h2 className="legal-section-title">
                    <span className="section-num">3.0</span> İzinler ve Kullanım Amaçları
                  </h2>
                  <p className="legal-paragraph">
                    Inexo Finance, yalnızca uygulamanın temel özelliklerini sunabilmek ve AdMob reklamlarını yükleyebilmek adına minimum sistem izinlerini kullanır:
                  </p>

                  <div className="data-table-wrapper">
                    <table className="data-table">
                      <thead>
                        <tr>
                          {data.permissionsTable.headers.map((h, i) => (
                            <th key={i}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {data.permissionsTable.rows.map((row, idx) => (
                          <tr key={idx}>
                            <td><code className="meta-code">{row.perm}</code></td>
                            <td>{row.purpose}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </section>

                <section id="sec-matrix" className="legal-section">
                  <h2 className="legal-section-title">
                    <span className="section-num">4.0</span> Google Play Store Veri Güvenliği Beyan Tablosu
                  </h2>
                  <p className="legal-paragraph">
                    Google Play Store "Veri Güvenliği" (Data Safety) standartları kapsamında beyan edilen veri işleme matrisi:
                  </p>

                  <div className="data-table-wrapper">
                    <table className="data-table">
                      <thead>
                        <tr>
                          {data.table.headers.map((h, i) => (
                            <th key={i}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {data.table.rows.map((row, idx) => (
                          <tr key={idx}>
                            <td><strong>{row.category}</strong></td>
                            <td><span className="badge-no">{row.collected}</span></td>
                            <td><span className="badge-no">{row.remote}</span></td>
                            <td><span className="badge-no">{row.sharing}</span></td>
                            <td>
                              <span className={row.isLocal ? "badge-local" : ""}>
                                {row.storage}
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </section>

                <section id="sec-deletion" className="legal-section">
                  <h2 className="legal-section-title">
                    <span className="section-num">5.0</span> Veri Güvenliği ve Silme Hakkı
                  </h2>
                  <ol className="legal-list">
                    <li>
                      <strong>Veri Kontrolü:</strong> Kullanıcı, dilediği an uygulama içindeki <em>Ayarlar &gt; Tüm Verileri Sıfırla</em> seçeneğini kullanarak veya uygulamanın verilerini/önbelleğini temizleyerek tüm yerel kayıtlarını anında ve kalıcı olarak silebilir.
                    </li>
                    <li>
                      <strong>Uygulama Kaldırma:</strong> Uygulama cihazdan kaldırıldığında cihazda tutulan tüm veritabanı dosyaları işletim sistemi tarafından otomatik olarak imha edilir.
                    </li>
                  </ol>
                </section>

                <section id="sec-children" className="legal-section">
                  <h2 className="legal-section-title">
                    <span className="section-num">6.0</span> Çocukların Gizliliği
                  </h2>
                  <p className="legal-paragraph">
                    Inexo Finance, 13 yaşın (veya ilgili ülkedeki yasal sınırın) altındaki çocuklara yönelik değildir ve bilerek çocuklardan kişisel veri toplamaz.
                  </p>
                </section>

                <section id="sec-changes" className="legal-section">
                  <h2 className="legal-section-title">
                    <span className="section-num">7.0</span> Politika Güncellemeleri
                  </h2>
                  <p className="legal-paragraph">
                    Gizlilik politikamız zaman zaman yasal veya operasyonel gereksinimler doğrultusunda güncellenebilir. Güncel sürüm her zaman uygulama içinden ve bu dokümandan erişilebilir olacaktır.
                  </p>
                </section>

                <section id="sec-contact" className="legal-section">
                  <h2 className="legal-section-title">
                    <span className="section-num">8.0</span> İletişim Bilgileri
                  </h2>
                  <p className="legal-paragraph">
                    Gizlilik politikamız veya uygulamamızla ilgili her türlü soru, öneri ve talepleriniz için bizimle iletişime geçebilirsiniz:
                  </p>

                  <div className="formal-contact-card">
                    <div className="contact-row">
                      <label>{data.contact.labels.app}</label>
                      <span>{data.contact.app}</span>
                    </div>
                    <div className="contact-row">
                      <label>{data.contact.labels.packageId}</label>
                      <span>{data.contact.packageId}</span>
                    </div>
                    <div className="contact-row">
                      <label>{data.contact.labels.developer}</label>
                      <span>{data.contact.developer}</span>
                    </div>
                    <div className="contact-row">
                      <label>{data.contact.labels.email}</label>
                      <a href={`mailto:${data.contact.email}`}>{data.contact.email}</a>
                    </div>
                    <div className="contact-row">
                      <label>{data.contact.labels.website}</label>
                      <a href={`https://${data.contact.website}`} target="_blank" rel="noopener noreferrer">{data.contact.website}</a>
                    </div>
                  </div>
                </section>
              </div>
            ) : (
              /* ==================== ENGLISH LEGAL TEXT ==================== */
              <div>
                <section id="sec-overview" className="legal-section">
                  <h2 className="legal-section-title">
                    <span className="section-num">1.0</span> Overview and Core Philosophy
                  </h2>
                  <p className="legal-paragraph">
                    <strong>Inexo Finance</strong> is a modern personal finance tracking application designed to help users manage their personal budgets, expenses, income, and savings goals with a privacy-first methodology.
                  </p>
                  <div className="legal-clause">
                    <strong>Our Core Guarantee:</strong>
                    Your financial data belongs exclusively to you. Inexo Finance never transmits, stores, or sells your income or expense records to any external server or third party.
                  </div>
                </section>

                <section id="sec-data" className="legal-section">
                  <h2 className="legal-section-title">
                    <span className="section-num">2.0</span> Collected & Processed Data
                  </h2>

                  <h3 className="legal-subsection-title">a. Financial Records & Notes (100% Offline / Local Storage)</h3>
                  <p className="legal-paragraph">
                    Your transactions, expenses, incomes, budget thresholds, savings goals, and transaction notes are stored solely within the local <strong>SQLite</strong> database situated on your physical device.
                  </p>
                  <p className="legal-paragraph">
                    This data never leaves your device and cannot be accessed remotely by anyone, including the developer.
                  </p>

                  <h3 className="legal-subsection-title">b. Biometric Authentication (Fingerprint / Face Recognition)</h3>
                  <p className="legal-paragraph">
                    Inexo Finance offers an optional biometric lock feature to protect your app from unauthorized access. Authentication is processed entirely by your device operating system hardware (Android Keystore / BiometricPrompt, iOS LocalAuthentication / Secure Enclave).
                  </p>
                  <p className="legal-paragraph">
                    Our application never observes, collects, or stores your biometric data; it receives solely a confirmation of whether the authentication attempt succeeded or failed.
                  </p>

                  <h3 className="legal-subsection-title">c. Notifications & Alarms</h3>
                  <p className="legal-paragraph">
                    The app schedules local notifications for daily expense reminders and upcoming recurring bills. These run locally on your device's built-in scheduler without sending personal data to remote push notification servers.
                  </p>
                </section>

                <section id="sec-admob" className="legal-section">
                  <h2 className="legal-section-title">
                    <span className="section-num">2.1</span> Advertising Services (Google AdMob)
                  </h2>
                  <p className="legal-paragraph">
                    To offer this application free of charge, the Google Mobile Ads (AdMob) SDK is integrated.
                  </p>
                  <ul className="legal-list">
                    <li>
                      AdMob may process device identifiers (Google Advertising ID - GAID) and approximate location/device telemetry in accordance with Google's policies for ad serving, fraud mitigation, and performance diagnostics.
                    </li>
                    <li>
                      <strong>Non-Personalized Ads:</strong> Inexo Finance configures AdMob requests to prioritize <strong>Non-Personalized Ads</strong>, ensuring that your financial records are never linked to advertising profiles.
                    </li>
                    <li>
                      For comprehensive details on how Google handles data, please review the <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" style={{ color: "var(--secondary)", textDecoration: "underline" }}>Google Privacy & Terms</a>.
                    </li>
                  </ul>
                </section>

                <section id="sec-permissions" className="legal-section">
                  <h2 className="legal-section-title">
                    <span className="section-num">3.0</span> Permissions & Usage Purposes
                  </h2>
                  <p className="legal-paragraph">
                    Inexo Finance requests strictly the minimal permissions essential to operate its features and deliver AdMob ad placements:
                  </p>

                  <div className="data-table-wrapper">
                    <table className="data-table">
                      <thead>
                        <tr>
                          {data.permissionsTable.headers.map((h, i) => (
                            <th key={i}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {data.permissionsTable.rows.map((row, idx) => (
                          <tr key={idx}>
                            <td><code className="meta-code">{row.perm}</code></td>
                            <td>{row.purpose}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </section>

                <section id="sec-matrix" className="legal-section">
                  <h2 className="legal-section-title">
                    <span className="section-num">4.0</span> Google Play Store Data Safety Disclosure Matrix
                  </h2>
                  <p className="legal-paragraph">
                    Our compliance matrix declared under Google Play Store "Data Safety" requirements:
                  </p>

                  <div className="data-table-wrapper">
                    <table className="data-table">
                      <thead>
                        <tr>
                          {data.table.headers.map((h, i) => (
                            <th key={i}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {data.table.rows.map((row, idx) => (
                          <tr key={idx}>
                            <td><strong>{row.category}</strong></td>
                            <td><span className="badge-no">{row.collected}</span></td>
                            <td><span className="badge-no">{row.remote}</span></td>
                            <td><span className="badge-no">{row.sharing}</span></td>
                            <td>
                              <span className={row.isLocal ? "badge-local" : ""}>
                                {row.storage}
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </section>

                <section id="sec-deletion" className="legal-section">
                  <h2 className="legal-section-title">
                    <span className="section-num">5.0</span> Data Security & Deletion Rights
                  </h2>
                  <ol className="legal-list">
                    <li>
                      <strong>Data Control:</strong> You can permanently wipe all local database entries at any time via <em>Settings &gt; Reset All Data</em> or by clearing app storage and cache through your device settings.
                    </li>
                    <li>
                      <strong>App Uninstallation:</strong> Uninstalling the application prompts the mobile operating system to immediately and permanently destroy all sandboxed SQLite database files.
                    </li>
                  </ol>
                </section>

                <section id="sec-children" className="legal-section">
                  <h2 className="legal-section-title">
                    <span className="section-num">6.0</span> Children's Privacy
                  </h2>
                  <p className="legal-paragraph">
                    Inexo Finance is not directed at children under the age of 13 (or the applicable statutory age limit) and does not knowingly solicit or collect personal information from minors.
                  </p>
                </section>

                <section id="sec-changes" className="legal-section">
                  <h2 className="legal-section-title">
                    <span className="section-num">7.0</span> Policy Revisions
                  </h2>
                  <p className="legal-paragraph">
                    This Privacy Policy may be updated periodically to accommodate legal or operational refinements. The current version will always remain accessible within the app and via this document.
                  </p>
                </section>

                <section id="sec-contact" className="legal-section">
                  <h2 className="legal-section-title">
                    <span className="section-num">8.0</span> Contact Information
                  </h2>
                  <p className="legal-paragraph">
                    For any questions, suggestions, or requests regarding our Privacy Policy or data handling practices, please contact us:
                  </p>

                  <div className="formal-contact-card">
                    <div className="contact-row">
                      <label>{data.contact.labels.app}</label>
                      <span>{data.contact.app}</span>
                    </div>
                    <div className="contact-row">
                      <label>{data.contact.labels.packageId}</label>
                      <span>{data.contact.packageId}</span>
                    </div>
                    <div className="contact-row">
                      <label>{data.contact.labels.developer}</label>
                      <span>{data.contact.developer}</span>
                    </div>
                    <div className="contact-row">
                      <label>{data.contact.labels.email}</label>
                      <a href={`mailto:${data.contact.email}`}>{data.contact.email}</a>
                    </div>
                    <div className="contact-row">
                      <label>{data.contact.labels.website}</label>
                      <a href={`https://${data.contact.website}`} target="_blank" rel="noopener noreferrer">{data.contact.website}</a>
                    </div>
                  </div>
                </section>
              </div>
            )}

          </main>
        </div>
      </div>
    </div>
  );
}

export default InexoPrivacy;
